/**
 * @generated SignedSource<<a77497b376fc8c34d6c3598461cf131b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteTimelineEntryInput = {
  clientMutationId?: string | null | undefined;
  timelineEntryId?: string | null | undefined;
};
export type TimelineEntriesField_DeleteMutation$variables = {
  input: DeleteTimelineEntryInput;
};
export type TimelineEntriesField_DeleteMutation$data = {
  readonly deleteTimelineEntry: {
    readonly timelineEntry: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type TimelineEntriesField_DeleteMutation = {
  response: TimelineEntriesField_DeleteMutation$data;
  variables: TimelineEntriesField_DeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimelineEntriesField_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteTimelineEntryPayload",
        "kind": "LinkedField",
        "name": "deleteTimelineEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimelineEntry",
            "kind": "LinkedField",
            "name": "timelineEntry",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimelineEntriesField_DeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeleteTimelineEntryPayload",
        "kind": "LinkedField",
        "name": "deleteTimelineEntry",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TimelineEntry",
            "kind": "LinkedField",
            "name": "timelineEntry",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "deleteRecord",
                "key": "",
                "kind": "ScalarHandle",
                "name": "id"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "80b4d540e63405d9da605bbb260b3ee8",
    "id": null,
    "metadata": {},
    "name": "TimelineEntriesField_DeleteMutation",
    "operationKind": "mutation",
    "text": "mutation TimelineEntriesField_DeleteMutation(\n  $input: DeleteTimelineEntryInput!\n) {\n  deleteTimelineEntry(input: $input) {\n    timelineEntry {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e3be7b29ed9659c213a1713e8ca5cdbe";

export default node;
